export const groupSizes = [
  {
    value: '10',
    label: '5-10',
    bucketNum: 2,
    tableRow: 0,
  },
  {
    value: '50',
    label: '11-50',
    bucketNum: 3,
    tableRow: 1,
  },
  {
    value: '100',
    label: '51-100',
    bucketNum: 4,
    tableRow: 2,
  },
  {
    value: '500',
    label: '101-500',
    bucketNum: 5,
    tableRow: 3,
  },
  {
    value: '1000',
    label: '501-1000',
    bucketNum: 6,
    tableRow: 4,
  },
  {
    value: '2000',
    label: '1001-2000',
    bucketNum: 6,
    tableRow: 5,
  },
  {
    value: '5000',
    label: '2001-5000',
    bucketNum: 6,
    tableRow: 6,
  },
  {
    value: '7500',
    label: '5001-7500',
    bucketNum: 6,
    tableRow: 7,
  },
  {
    value: '10000',
    label: '7500+',
    bucketNum: 6,
    tableRow: 8,
  },
]

// Coefficients come from this table
// https://docs.google.com/spreadsheets/d/1ufd7AuKWfYwfpBZ_JjPUpaVdZ3MObW3el9fHSP6yplo/edit#gid=1225314778
export const clientUseCases = [
  {
    value: 'Learning & Development Tool',
    labelId: 'groupForm.seats.form.useCases.learningDevelopment',
    coefficient: 1.199015162,
    tableCol: 3,
    salesAmplifier: 4,
  },
  {
    value: 'Employee Perk or Benefit',
    labelId: 'groupForm.seats.form.useCases.perksBenefits',
    coefficient: 1.409343882,
    tableCol: 1,
  },
  {
    value: 'Gift',
    labelId: 'groupForm.seats.form.useCases.gift',
    coefficient: 1.697113104,
    tableCol: 2,
  },
  {
    value: 'Partnership',
    labelId: 'groupForm.seats.form.useCases.partnership',
    coefficient: 1.199015162,
    tableCol: 3,
    salesAmplifier: 4,
  },
  {
    value: 'Assistance with a Refund',
    labelId: 'groupForm.seats.form.useCases.refund',
    coefficient: 0,
    tableCol: 0,
    salesAmplifier: 0,
  },
  {
    value: 'Other',
    labelId: 'groupForm.seats.form.useCases.other',
    coefficient: 0.0,
    tableCol: 0,
  },
]

// Win Rate & Avg Deal Size sourced from this doc
// docs.google.com/presentation/d/1M-YQ_yHYfDSHZt7Dg6fBUVPaSy5xkVerJIxJY5q6ZSU/edit
export const winRateTable = [
  [0.5, 0.5, 0.833, 0.69], // group size 5-10
  [0.647, 0.628, 0.767, 0.496], // group size 11-50
  [0.333, 0.469, 0.623, 0.4], // group size 51-100
  [0.143, 0.372, 0.647, 0.282], // group size 101-500
  [0.538, 0.319, 0.444, 0.288], // group size 501-1000
  [0.538, 0.319, 0.444, 0.288], // group size 1001-2000
  [0.538, 0.319, 0.444, 0.288], // group size 2001-5000
  [0.538, 0.319, 0.444, 0.288], // group size 5001-7500
  [0.538, 0.319, 0.444, 0.288], // group size 7500+
]

export const avgDealSizeTable = [
  [90, 722, 1415, 1182], // group size 5-10
  [3012, 2830, 3523, 2613], // group size 11-50
  [7380, 4574, 5416, 4900], // group size 51-100
  [2529, 10873, 12194, 8403], // group size 101-500
  [43999, 21171, 22708, 12719], // group size 501-1000
  [43999, 21171, 22708, 12719], // group size 1001-2000
  [43999, 21171, 22708, 12719], // group size 2001-5000
  [43999, 21171, 22708, 12719], // group size 5001-7500
  [43999, 21171, 22708, 12719], // group size 7500+
]

export const NO_HUBSPOT_EMAIL_KEYWORD = 'nohubspot'

export const S2S_FEATURE_FLAG = 'straight-to-scheduling'

export const HUBSPOT_PURCHASE_FORM_ID = '0dc14428-33d2-4620-8af1-8ff3b33e55e8'

// New form
export const HUBSPOT_FORM_ID = '6d2c483a-be86-4b84-9ad6-e79419aab5cc'
